/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { BVQReportProvider } from 'src/app/providers/bvq';
import { BVQReportService } from '../../services';
import { LogService } from 'src/app/services';


@Component({
  selector: 'ask',
  templateUrl: 'ask.html',
  styleUrls: ['ask.scss']
})
export class AskComponent implements OnInit, AfterViewInit {
  @Input() askQuestion = true;
  @Input() fieldName: string;
  @Input() bottom: string;
  @Input() top: string = null;
  @Input() right: string;
  @Input() left: string;
  @Input() disabled: boolean = false;
  @Input() resendQuestion: boolean;
  @Input() type: string = '';

  constructor(
    private reportProvider: BVQReportProvider,
    private reportService: BVQReportService,
    private elRef: ElementRef,
    private renderer: Renderer2,
    private logService : LogService
  ) {
  }

  ngOnInit(): void {
    if (this.askQuestion == null)
      this.askQuestion = true;
  }

  ngAfterViewInit(): void {
    if (this.top) {
      this.renderer.setStyle(this.elRef.nativeElement, 'top', this.top);
    }
    if (this.bottom) {
      this.renderer.setStyle(this.elRef.nativeElement, 'bottom', this.bottom);
    }
    if (this.right) {
      this.renderer.setStyle(this.elRef.nativeElement, 'right', this.right);
    }
    if (this.left) {
      this.renderer.setStyle(this.elRef.nativeElement, 'left', this.left);
    }
  }

  toggleAsk(): void {
    if(!this.disabled){
      this.askQuestion = !this.askQuestion;

      this.reportProvider.setAsk(this.reportService.getReport(), this.fieldName, this.askQuestion)
        .subscribe(
          data => {
            if (data.success) {
              // this.logService.log("Save Report Successfully!");
              this.reportService.updateAskField(this.fieldName, this.askQuestion);

            } else this.logService.log('Error Saving Ask for Report!');
          }, err => {
            this.logService.log('Error Saving Ask for Report [' + err + ']');
          });
    }

  }

  /** Toggle Resend */
  toggleResend(): void {
    if(!this.disabled){
      this.resendQuestion = !this.resendQuestion;

      this.reportProvider.setResend(this.reportService.getReport(), this.fieldName, this.resendQuestion)
        .subscribe(
          data => {
            if (data.success) {
              this.reportService.updateResendField(this.fieldName, this.resendQuestion);
            } else {
              this.logService.log('Error Saving Resend for Report!');
            }
          }, err => {
            this.logService.log('Error Saving Resend for Report [' + err + ']');
          });
    }
  }
}
